import { Subject } from 'rxjs';

interface NodeSaveEvent {
  nodeId: string;
  action: 'create' | 'update' | 'delete';
}

const nodeSaveSubject = new Subject<NodeSaveEvent>();

export const nodeSaved$ = nodeSaveSubject.asObservable();

export const emitNodeSaved = (
  nodeId: string,
  action: 'create' | 'update' | 'delete',
): void => {
  nodeSaveSubject.next({ nodeId, action });
};
